import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
   name: 'findIndex',
   standalone: true,
})
export class FindIndexPipe implements PipeTransform {
   transform(source: string, target: string[] = []): number | null {
      const foundIndex = target.findIndex((targetItem) => targetItem.startsWith(source));
      return foundIndex === -1 ? null : foundIndex + 1;
   }
}
